import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";


@Component({
	templateUrl: './mtma-generic-entry-info.dialog.component.html',
	styles: `
	`
})

export class MtmaGenericEntryInfoDialogComponent {
	row1: string = '';
	row2: string = '';

	constructor(
		private refDialog: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		if (config.data) {
			if (config.data.row1) {
				this.row1 = config.data.row1;
			}
			if (config.data.row2) {
				this.row2 = config.data.row2;
			}
		}
	}

	closeDialog(): void {
		this.refDialog.close();
	}

}